import "./GdprPage.scss";
import React from "react";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <article className="privacy-policy__article">
        <h1>Ochrana osobných údajov</h1>
        <h2>Informácie o spracúvaní osobných údajov na webe Penziónu Triferis</h2>

        <p>
          Tento dokument vysvetľuje, aké osobné údaje spracúvame, keď navštívite
          web triferis.sk, pošlete nám dopyt alebo si u nás rezervujete pobyt.
          Dozviete sa, prečo to robíme, ako dlho údaje uchovávame a aké máte
          práva. Postupujeme podľa nariadenia Európskeho parlamentu a Rady (EÚ)
          2016/679 (ďalej len „GDPR“) a zákona č. 18/2018 Z. z. o ochrane
          osobných údajov.
        </p>

        <h2>1. Kto je prevádzkovateľ</h2>
        <ul>
          <li>
            <strong>Obchodné meno:</strong> Táborčatá s. r. o.
          </li>
          <li>
            <strong>Sídlo:</strong> Budatínska 3230/16A, 851 06 Bratislava –
            mestská časť Petržalka
          </li>
          <li>
            <strong>IČO:</strong> 56 040 890
          </li>
          <li>
            <strong>Zápis:</strong> Obchodný register Mestského súdu Bratislava
            III, oddiel Sro, vložka č. 177035/B
          </li>
          <li>
            <strong>Prevádzka:</strong> Penzión Triferis, Bystrá 118, 977 01
            Bystrá
          </li>
          <li>
            <strong>E-mail:</strong>{" "}
            <a href="mailto:info@triferis.sk">info@triferis.sk</a>
          </li>
          <li>
            <strong>Telefón:</strong>{" "}
            <a href="tel:+421 944 526 240">+421 944 526 240</a>
          </li>
        </ul>
        <p>
          <em>(ďalej len „my“ alebo „prevádzkovateľ“)</em>
        </p>

        <h2>2. Aké údaje spracúvame, prečo a na akom právnom základe</h2>

        <h3>A. Dopyt cez formulár, e-mail alebo telefón</h3>
        <ul>
          <li>
            <strong>Účel:</strong> vybavenie vášho dopytu – overenie voľného
            termínu, príprava cenovej ponuky a komunikácia k nej.
          </li>
          <li>
            <strong>Právny základ:</strong> opatrenia pred uzavretím zmluvy na
            vašu žiadosť (čl. 6 ods. 1 písm. b) GDPR). Ak dopyt posielate za
            školu, firmu alebo združenie, vaše kontaktné údaje spracúvame na
            základe oprávneného záujmu komunikovať s kontaktnou osobou (čl. 6
            ods. 1 písm. f) GDPR).
          </li>
          <li>
            <strong>Údaje:</strong> meno a organizácia, e-mail alebo telefón,
            typ pobytu, počet osôb, termín príchodu a odchodu a to, čo nám
            napíšete do poznámky. Do poznámky, prosím, nepíšte citlivé údaje o
            konkrétnych osobách, napríklad zdravotné diagnózy. Požiadavky na
            stravu alebo zdravotníka stačí uviesť všeobecne.
          </li>
        </ul>

        <h3>B. Rezervácia a pobyt</h3>
        <ul>
          <li>
            <strong>Účel:</strong> uzavretie a plnenie zmluvy o ubytovaní a
            súvisiacich službách (strava, doprava, program) a komunikácia pred
            pobytom a počas neho.
          </li>
          <li>
            <strong>Právny základ:</strong> plnenie zmluvy (čl. 6 ods. 1 písm.
            b) GDPR) a plnenie zákonných povinností ubytovacieho zariadenia (čl.
            6 ods. 1 písm. c) GDPR), najmä evidencia ubytovaných hostí, hlásenie
            pobytu cudzincov a miestna daň za ubytovanie.
          </li>
          <li>
            <strong>Údaje:</strong> identifikačné a kontaktné údaje
            objednávateľa, údaje o pobyte a platbe; pri ubytovaní údaje hostí v
            rozsahu, ktorý ukladajú právne predpisy.
          </li>
        </ul>

        <h3>C. Účtovníctvo a dane</h3>
        <ul>
          <li>
            <strong>Účel:</strong> vystavovanie a evidencia účtovných dokladov a
            plnenie daňových povinností.
          </li>
          <li>
            <strong>Právny základ:</strong> plnenie zákonnej povinnosti (čl. 6
            ods. 1 písm. c) GDPR), najmä podľa zákona o účtovníctve a daňových
            predpisov.
          </li>
          <li>
            <strong>Údaje:</strong> fakturačné a platobné údaje (meno alebo
            názov, adresa, IČO, suma, údaje o úhrade).
          </li>
        </ul>

        <h3>D. Ochrana formulára pred zneužitím</h3>
        <ul>
          <li>
            <strong>Účel:</strong> overenie, že dopytový formulár neodosiela
            robot.
          </li>
          <li>
            <strong>Právny základ:</strong> náš oprávnený záujem chrániť web a
            schránku pred spamom (čl. 6 ods. 1 písm. f) GDPR).
          </li>
          <li>
            <strong>Údaje:</strong> IP adresa a technické údaje o prehliadači a
            zariadení, ktoré pri overení spracúva služba Cloudflare Turnstile.
          </li>
        </ul>

        <h3>E. Meranie reklamy (Meta Pixel)</h3>
        <ul>
          <li>
            <strong>Účel:</strong> merať, či naša reklama na Facebooku a
            Instagrame privádza návštevníkov na web.
          </li>
          <li>
            <strong>Právny základ:</strong> váš súhlas (čl. 6 ods. 1 písm. a)
            GDPR). Udeľujete ho v cookie lište zapnutím marketingových cookies a
            kedykoľvek ho zmeníte cez „Nastavenia cookies“ v pätičke webu.
          </li>
          <li>
            <strong>Údaje:</strong> IP adresa, identifikátory uložené v
            cookies, technické údaje o prehliadači a zariadení, navštívené
            stránky webu a kliknutia na tlačidlá. Podrobnosti sú v dokumente{" "}
            <Link to="/cookie-politika">Cookies</Link>.
          </li>
          <li>
            <strong>Spoločné prevádzkovanie:</strong> pri zbere týchto údajov a
            ich odovzdaní spoločnosti Meta Platforms Ireland Limited sme s ňou
            spoloční prevádzkovatelia (čl. 26 GDPR). Ako údaje ďalej spracúva,
            napríklad pri výbere reklamy, ktorú vám zobrazí, určuje Meta vo
            svojich{" "}
            <a
              href="https://www.facebook.com/privacy/policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              zásadách ochrany súkromia
            </a>
            . Svoje práva môžete uplatniť u nás aj priamo u spoločnosti Meta.
          </li>
        </ul>

        <h3>F. Vložená mapa</h3>
        <ul>
          <li>
            <strong>Účel:</strong> ukázať vám polohu penziónu priamo na stránke.
          </li>
          <li>
            <strong>Právny základ:</strong> náš oprávnený záujem uľahčiť vám
            cestu k nám (čl. 6 ods. 1 písm. f) GDPR).
          </li>
          <li>
            <strong>Údaje:</strong> IP adresa a technické údaje o prehliadači,
            ktoré pri načítaní mapy spracúva spoločnosť Google.
          </li>
        </ul>

        <h2>3. Údaje detí</h2>
        <p>
          Cez web nezbierame údaje detí ani zoznamy účastníkov pobytov. Ak dopyt
          posiela škola alebo organizátor tábora, stačí nám počet osôb.
        </p>

        <h2>4. Ako dlho údaje uchovávame</h2>
        <ul>
          <li>
            <strong>Dopyty, z ktorých nevznikla rezervácia:</strong> najviac 12
            mesiacov od poslednej komunikácie.
          </li>
          <li>
            <strong>Rezervácie a pobyty:</strong> počas trvania zmluvy a 3 roky
            po jej skončení pre prípad uplatnenia právnych nárokov.
          </li>
          <li>
            <strong>Účtovné doklady:</strong> 10 rokov nasledujúcich po roku,
            ktorého sa týkajú.
          </li>
          <li>
            <strong>Evidencia ubytovaných hostí:</strong> po dobu, ktorú ukladajú
            osobitné predpisy.
          </li>
          <li>
            <strong>Údaje z cookies:</strong> podľa dokumentu{" "}
            <Link to="/cookie-politika">Cookies</Link>; súhlas platí, kým ho
            neodvoláte.
          </li>
        </ul>

        <h2>5. Komu údaje sprístupňujeme</h2>
        <p>
          Vaše údaje nepredávame. Prístup k nim majú len naši zamestnanci a
          dodávatelia, ktorých potrebujeme na prevádzku penziónu a webu:
        </p>
        <ul>
          <li>poskytovateľ webhostingu a e-mailových služieb,</li>
          <li>Cloudflare, Inc. – ochrana formulára Turnstile,</li>
          <li>
            Google Ireland Limited – Google Tag Manager (len s vaším súhlasom) a
            vložená mapa,
          </li>
          <li>
            Meta Platforms Ireland Limited – Meta Pixel (len s vaším súhlasom,
            ako spoločný prevádzkovateľ podľa časti E),
          </li>
          <li>poskytovatelia účtovných a daňových služieb,</li>
          <li>
            orgány verejnej moci, ak nám to ukladá zákon – napríklad obec ako
            správca dane za ubytovanie, polícia pri hlásení pobytu cudzincov
            alebo daňový úrad.
          </li>
        </ul>

        <h2>6. Prenos údajov mimo Európskej únie</h2>
        <p>
          Údaje spracúvame v Európskej únii a Európskom hospodárskom priestore.
          Pri službách spoločností Google, Meta a Cloudflare môže dôjsť k prenosu
          údajov do USA. Prenos sa opiera o rozhodnutie o primeranosti (EU–US
          Data Privacy Framework), prípadne o štandardné zmluvné doložky
          schválené Európskou komisiou.
        </p>

        <h2>7. Automatizované rozhodovanie</h2>
        <p>
          Nerobíme žiadne rozhodnutia založené výlučne na automatizovanom
          spracúvaní vrátane profilovania, ktoré by mali pre vás právne účinky.
        </p>

        <h2>8. Aké máte práva</h2>
        <ul>
          <li>
            <strong>Právo na prístup (čl. 15 GDPR):</strong> môžete sa opýtať,
            či vaše údaje spracúvame, a získať ich kópiu.
          </li>
          <li>
            <strong>Právo na opravu (čl. 16 GDPR):</strong> ak sú údaje
            nesprávne alebo neúplné, opravíme ich.
          </li>
          <li>
            <strong>Právo na vymazanie (čl. 17 GDPR):</strong> môžete žiadať
            vymazanie údajov, ak už nie sú potrebné, ak odvoláte súhlas alebo ak
            sa spracúvali nezákonne.
          </li>
          <li>
            <strong>Právo na obmedzenie spracúvania (čl. 18 GDPR):</strong>{" "}
            napríklad na čas, kým overíme správnosť údajov.
          </li>
          <li>
            <strong>Právo na prenosnosť (čl. 20 GDPR):</strong> údaje, ktoré ste
            nám poskytli, vám vydáme v bežne používanom, strojovo čitateľnom
            formáte.
          </li>
          <li>
            <strong>Právo namietať (čl. 21 GDPR):</strong> ak údaje spracúvame
            na základe oprávneného záujmu, môžete proti tomu namietať.
          </li>
          <li>
            <strong>Právo odvolať súhlas:</strong> súhlas s cookies zmeníte cez
            „Nastavenia cookies“ v pätičke. Odvolanie nemá vplyv na zákonnosť
            spracúvania pred odvolaním.
          </li>
        </ul>
        <p>
          Žiadosť pošlite e-mailom na{" "}
          <a href="mailto:info@triferis.sk">info@triferis.sk</a> alebo poštou na
          adresu sídla: Táborčatá s. r. o., Budatínska 3230/16A, 851 06
          Bratislava. Odpovieme do jedného mesiaca.
        </p>

        <h2>9. Sťažnosť dozornému orgánu</h2>
        <p>
          Ak si myslíte, že vaše údaje spracúvame v rozpore s predpismi, môžete
          podať návrh na začatie konania o ochrane osobných údajov:
        </p>
        <address>
          <strong>Úrad na ochranu osobných údajov Slovenskej republiky</strong>
          <br />
          Galvaniho 7/B, 821 04 Bratislava
          <br />
          E-mail:{" "}
          <a href="mailto:statny.dozor@pdp.gov.sk">statny.dozor@pdp.gov.sk</a>
          <br />
          Web:{" "}
          <a
            href="https://dataprotection.gov.sk/"
            target="_blank"
            rel="noopener noreferrer"
          >
            dataprotection.gov.sk
          </a>
        </address>

        <h2>10. Bezpečnosť</h2>
        <p>
          Web používa šifrované spojenie (HTTPS). K údajom z dopytov a
          rezervácií majú prístup len poverené osoby, ktoré ich potrebujú na
          svoju prácu.
        </p>

        <p>
          <em>
            Tieto informácie sú účinné od 11. 10. 2026. Ak sa zmenia predpisy
            alebo naše postupy, aktualizujeme ich. Aktuálna verzia je vždy na
            webe triferis.sk.
          </em>
        </p>
      </article>
    </div>
  );
};

export default PrivacyPolicy;
